import { ReactNode, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GoogleFontIcon, Input } from '@asset-metrix/portal-ui';
import { useShallow } from 'zustand/react/shallow';

import { useStore } from '../../store';
import { SearchFilterData } from '../../store/states/filterTypes';

export type SearchFilterProps = {
  entityId: string;
  filterData?: SearchFilterData;
  filterKey: string;
  isFetching: boolean;
  label?: ReactNode | ReactNode[];
};

export function SearchFilter({
  entityId,
  filterData,
  filterKey,
  isFetching,
  label,
}: SearchFilterProps) {
  const [value, setValue] = useState(filterData?.selection ?? '');
  useEffect(() => {
    setValue(filterData?.selection ?? '');
  }, [filterData?.selection]);

  const [setFilterSelectionValue, resetFilterSelections] = useStore(
    useShallow((state) => [
      state.setFilterSelectionValue,
      state.resetFilterSelections,
    ])
  );

  const { t } = useTranslation();
  return (
    <Input
      data-testid="search-filter"
      leftSection={<GoogleFontIcon name="search" />}
      clearable={true}
      label={label}
      loading={isFetching}
      placeholder={t('app.search.placeholder')}
      value={value}
      onCommit={(value) => {
        if (value !== '') {
          setFilterSelectionValue(entityId, filterKey, value);
        } else {
          resetFilterSelections(entityId, filterKey);
        }
      }}
      onChange={setValue}
    />
  );
}
